// Cyberpunk-watercolor icon set. Hand-sketched stroke, Ultraviolet ink.
// All icons accept className/size and render at 24px by default.

interface IconProps { size?: number; className?: string; color?: string; }

const base = (size: number, color: string, children: React.ReactNode) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

export const IconGlobe = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" />
  </>
));

export const IconLightning = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <path d="M13 3 4 14h6l-1 7 9-11h-6l1-7z" />
));

export const IconStar = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <path d="m12 3 2.6 5.6 6 .6-4.5 4.1 1.4 6.1L12 16.6 6.5 19.4l1.4-6.1L3.4 9.2l6-.6L12 3Z" />
));

export const IconDroplet = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <path d="M12 3s6 7 6 11a6 6 0 0 1-12 0c0-4 6-11 6-11Z" />
));

export const IconTarget = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
  </>
));

export const IconDataNode = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <>
    <polygon points="12,3 21,8 21,16 12,21 3,16 3,8" />
    <circle cx="12" cy="12" r="2.2" />
  </>
));

export const IconSpark = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <>
    <path d="M12 3v6M12 15v6M3 12h6M15 12h6" />
    <path d="m6 6 3 3M15 15l3 3M18 6l-3 3M9 15l-3 3" />
  </>
));

export const IconPlus = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <path d="M12 5v14M5 12h14" />
));

export const IconArrowRight = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <path d="M5 12h14M13 5l7 7-7 7" />
));

export const IconChevronLeft = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <path d="m15 18-6-6 6-6" />
));

export const IconLens = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-4.3-4.3" />
  </>
));

export const IconHeart = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10Z" />
));

export const IconChat = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <>
    <path d="M4 5h16v12H8l-4 4z" />
    <circle cx="9" cy="11" r="0.7" fill={color} />
    <circle cx="12" cy="11" r="0.7" fill={color} />
    <circle cx="15" cy="11" r="0.7" fill={color} />
  </>
));

export const IconCheck = ({ size = 24, color = 'currentColor' }: IconProps) => base(size, color, (
  <path d="M4 12l5 5 11-12" />
));
